import { getOsType } from '@utils/utils'

export const hotkeys = [
  {
    key: getOsType() == 'mac' ? 'Meta+N' : 'Ctrl+N',
    action: 'new',
    label: 'pages.Hotkey.new',
    hideInWeb: true,
    needPro: false,
  },
  {
    key: getOsType() == 'mac' ? 'Meta+/' : 'Ctrl+/',
    action: 'edit',
    label: 'pages.Hotkey.input',
    hideInWeb: false,
    needPro: false,
  },
  {
    key: ['Enter'],
    action: 'newBlank',
    label: 'pages.Hotkey.newBlank',
    hideInWeb: false,
    needPro: false,
    special: true,
  },
  {
    key: getOsType() == 'mac' ? ['Meta+Enter', 'Shift+Enter'] : ['Ctrl+Enter', 'Shift+Enter'],
    action: 'save',
    label: 'pages.Hotkey.save',
    hideInWeb: false,
    needPro: false,
    special: true,
  },
  {
    key: getOsType() == 'mac' ? 'Meta+K' : 'Ctrl+K',
    action: 'search',
    label: 'pages.Hotkey.search',
    hideInWeb: false,
    needPro: false,
  },
  {
    key: getOsType() == 'mac' ? 'Meta+Shift+L' : 'Ctrl+Shift+L',
    action: 'password',
    label: 'pages.Hotkey.password',
    hideInWeb: false,
    needPro: true,
  },

  {
    key: getOsType() == 'mac' ? 'Meta+\\' : 'Ctrl+\\',
    action: 'toggleSidebar',
    label: 'pages.Hotkey.toggleSidebar',
    hideInWeb: false,
    needPro: false,
  },

  {
    key: getOsType() == 'mac' ? 'Meta+Shift+F' : 'Ctrl+Shift+F',
    action: 'home',
    label: 'pages.Hotkey.home',
    hideInWeb: false,
    needPro: false,
  },
  {
    key: getOsType() == 'mac' ? 'Meta+R' : 'Ctrl+R',
    action: 'reload',
    label: 'pages.Hotkey.reload',
    hideInWeb: true,
    needPro: false,
  },
  {
    key: getOsType() == 'mac' ? 'Meta+Shift+O' : 'Ctrl+Shift+O',
    action: 'open',
    label: 'pages.Hotkey.open',
    hideInWeb: true,
    needPro: false,
  },
  {
    key: getOsType() == 'mac' ? 'Meta+,' : 'Ctrl+,',
    action: 'settings',
    label: 'pages.Hotkey.setting',
    hideInWeb: true,
    needPro: false,
  },
]
